module.exports = __webpack_public_path__ + "public/img/Sale07.73323491.png";